import ClueNoteModal from '~/pages/Mystery/Modal/ClueNoteModal/ClueNoteModal';
import GameEndModal from '~/pages/Mystery/Modal/GameEndModal/GameEndModal';
import { GuessingStep, MessageResponse } from '~/types';
import BottomSheetContainer from '../BottomSheet';
import ConceptChatHistoryContent from './ChatHistoryContent/ConceptChat/ChatHistoryContent';
import MysteryChatHistoryContent from './ChatHistoryContent/MysteryChat/ChatHistoryContent';

interface ModalProps {
  title?: string;
  step?: GuessingStep | null;
  messages: MessageResponse[];
  isOpen: boolean;
  onClose: () => void;
}

export default function ChatHistoryBottomSheet({
  title = '',
  step = null,
  messages,
  isOpen,
  onClose,
}: ModalProps) {
  const isMysteryChatPage = step !== null;

  return (
    <>
      {isMysteryChatPage ? <ClueNoteModal title={title} /> : null}
      <BottomSheetContainer
        isOpen={isOpen}
        openHeightRates={[0.94]}
        hideHandle
        disableContentDrag
        onClose={onClose}
        transparentBg
      >
        {isMysteryChatPage ? (
          <>
            <MysteryChatHistoryContent
              messages={messages}
              isOpen={isOpen}
              onClose={onClose}
            />
            {step === 'Conclusion' && <GameEndModal />}
          </>
        ) : (
          <ConceptChatHistoryContent
            messages={messages}
            isOpen={isOpen}
            onClose={onClose}
          />
        )}
      </BottomSheetContainer>
    </>
  );
}
